var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHarvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.857928 6.59016L6.39045 0L10.7423 4.89101L9.27434 11.972C8.77182 12.685 8.39912 13.496 8.1906 14.3708H6.36973L5.84836 10.3669L8.98194 4.77903L6.62192 1.92711L7.78254 4.66329L5.25382 8.67153L2.01831 7.53435L4.7457 10.3477L4.76485 14.3708H2.35755L0.857928 6.59016Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04832 15.1732H1.46398L1.45311 15.1743C-0.565889 16.1066 -0.433426 18.9808 1.55511 19.9878H9.24621C8.4605 18.8563 8 17.4819 8 16C8 15.7203 8.01641 15.4444 8.04832 15.1732Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3112 21.1977H9.08892C9.02185 21.453 8.93059 21.7047 8.84215 21.9487C8.72613 22.2688 8.61498 22.5754 8.56969 22.859L9.57947 24H11.9868L12.3441 22.4786C12.0203 22.3457 11.7087 22.1893 11.4114 22.0114L11.2501 22.4788L11.2252 21.896C10.9013 21.6882 10.5957 21.4545 10.3112 21.1977Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8188 9.09924L12.3647 7.07538L10.7379 9.79061C10.8057 9.9802 10.8699 10.1482 10.932 10.3027C11.7743 9.70024 12.7557 9.2799 13.8188 9.09924Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3326 10.7831C10.2938 10.7072 10.271 10.6629 10.271 10.6629L10.2314 10.8755C10.2648 10.8444 10.2985 10.8136 10.3326 10.7831Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12538 21.1965L3.96242 24H7.9746L8.4326 21.2036L7.16173 21.1887L6.57231 23.6528L5.70948 21.2058L3.12538 21.1965Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 24C20.4183 24 24 20.4183 24 16C24 11.5817 20.4183 8 16 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5817 24 16 24ZM16 23C19.866 23 23 19.866 23 16C23 12.134 19.866 9 16 9C12.134 9 9 12.134 9 16C9 19.866 12.134 23 16 23Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H17V21H15V11Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15H21V17H11V15Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarvest);
export default __webpack_public_path__ + "static/media/Harvest.5af42d3781f68cfe5e62ec9bcf681712.svg";
export { ForwardRef as ReactComponent };